module.exports = __webpack_public_path__ + "img/pricing_info.ad5e26b4.jpg";